import { Campaign } from '@app/shared/models/campaign';
import { Action, createReducer, on } from '@ngrx/store';
import { Constant } from 'src/constant';
import { AdvertisingActions } from '../actions';


export const advertisingFeatureKey = 'advertising';

export interface State {
  campaign: Campaign;
  campaignLoaded: boolean;
}

export const initialState: State = {
  campaign: null,
  campaignLoaded: false,
};

const advertisingReducer = createReducer(
  initialState,
  on(AdvertisingActions.LoadCampaign, (state) => ({
    ...state,
    campaign: null,
    campaignLoaded: false,
  })),
  on(AdvertisingActions.LoadCampaignSuccess, (state, { campaign }) => ({
    ...state,
    campaign,
    campaignLoaded: true,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return advertisingReducer(state, action);
}
